export const HideElementOnScrollEffectThreshold = {
  desktop: 480,
  mobile: 200,
};
